<div class="banner">
  <h1>Affiliates</h1>
</div>
<fgb-balance-bar></fgb-balance-bar>

<div class="container mt-4">
  <fgb-company-list [companies]="companies$ | async" [isList]="true"></fgb-company-list>
</div>
